export const DATE_OPTIONS: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
};

export const DATE_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
};

/**
 * export timestamp to string.
 * @param timestamp
 * @param options
 */
export function timestampToString(timestamp: number, options?: Intl.DateTimeFormatOptions) {
    const date = new Date(timestamp);
    return dateToString(date, options);
}

/**
 * convert date to locale string.
 * @param date
 * @param options
 */
export function dateToString(date: Date, options?: Intl.DateTimeFormatOptions) {
    return date.toLocaleDateString(window.navigator.language, options);
}
